import { useEffect, useRef ,useState } from "react";
import {useLocation } from 'react-router-dom'
import Animate from "./Animate";
// import ReactGA from "react-ga4";




const TetScene = () => {
    const [config, setConfig] = useState(null);
    const THREE = window.Tetavi.THREE;
    const [renderer, ] = useState(new THREE.WebGLRenderer());
    const [scene, ] = useState(new THREE.Scene());
    const [clickTouch, setClickTouch] = useState(false);

  
    const {search} = useLocation();

    const query = new URLSearchParams(search);
    const concert = query.get('concert');
      
    const page = query.get('page');
  
   
   /*if(!concert){
    
    window.location = ('https://vstage.xyz/?concert=Riell');
   }*/
    
    const fetchConfig=(concertName)=>{
        if(concertName.split('.').pop() != 'json'){
          concertName += '.json';
        }
        fetch(concertName
        // fetch("https://tmppoc3dsweb.z6.web.core.windows.net/" + concertName
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json',
           }
        }
        )
          .then(function(response){
            if(!response.ok) goToDefaultPage()
            // console.log(response.ok)
            return response.json();
          })
          .then(function(_config) {
            if(_config.loading_info){
              setConfig(_config)
            }else{
              setConfig("invalid")
              goToDefaultPage()
            }
            
          });
      }


      useEffect(() => {
        if(!config && concert && concert.length > 1){
          fetchConfig(concert )
        }else{
          fetchConfig("guy" )
        }
      }, []);

      function goToDefaultPage(){
        window.location = ('/?concert=YoomPlayer')
      }

      function onClickOrTouch(){
        setClickTouch(true);
      }
    
          
      
      function renderSwitch(page,concert,config) {
        if(concert && !config){
          return
        }
        if(concert && config && config!="invalid"){
          return (
            <div>
              {config.videos.map((video,key) => {
                return (
                  <div key={key}>
                    <video crossOrigin={"anonymous"} id={video.videoId} src={video.video} type={'video/mp4'} playsInline muted={true} loop={false} style={{display:"none"}}/> 
                  </div>)
                })}
              <Animate concert={concert} config={config} scene={scene}  renderer={renderer } clickTouch={clickTouch}/>
            </div>
          )
        }

        switch(page) {
          default:
            return goToDefaultPage();
        }
      }
  
  console.log(clickTouch);
  return (
    <div className="tet-scene-div" onTouchStart={onClickOrTouch} onClick={onClickOrTouch}>
        {renderSwitch(page,concert,config)}
    </div>
    
  );
}

export default TetScene;